import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Form from '../../../../../../components/Form'
import NameAndTypeSection from './sections/NameAndTypeSection'
import RightCreateFormContent from './RightCreateFormContent'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { transformValuesToBE } from './formatters'
import { useIsGamAccountConnectedToRightsHolderAccount } from './sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/hooks'

import { createRight, clearCreateRight } from '../../../../../../modules/actions/rights'
import {
  createdRightIsLoadingSelector,
  rightWasCreatedSelector,
  createdRightErrorSelector
} from '../../../../../../modules/selectors/rights'
import {
  selectedPartnershipIsDigitalSelector,
  selectedPartnershipSelector
} from '../../../../../../modules/selectors/partnerships'
import {
  getCurrentUserSelector,
  selectedPartnershipRightsHolderSelfAccountSelector
} from '../../../../../../modules/selectors/app'
import { selfAccountSelector } from '../../../../../../modules/selectors/selfAccounts'

import { RIGHT_CREATE } from '../../../../../../constants/forms'
import { getValidationSchema } from './validation'
import { getInitialValues } from './fields'
import { GAM_NETWORK_CODE } from './sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/fields'

function RightCreateForm() {
  const dispatch = useDispatch()

  const rightWasCreated = useSelector(rightWasCreatedSelector)
  const selectedPartnershipIsDigital = useSelector(selectedPartnershipIsDigitalSelector)
  const { id: partnershipId } = useSelector(selectedPartnershipSelector)

  const selfAccount = useSelector(selfAccountSelector)

  const isGamAccountConnected = useIsGamAccountConnectedToRightsHolderAccount()
  const gamNetworkCode = selfAccount?.[GAM_NETWORK_CODE]

  const { facebook_is_connected: facebookIsConnected } = useSelector(getCurrentUserSelector)

  const selectedPartnershipRightsHolderSelfAccount = useSelector(selectedPartnershipRightsHolderSelfAccountSelector)

  const rightsHolderAdServer = selectedPartnershipRightsHolderSelfAccount?.ad_server

  const onSubmit = useCallback(
    values => {
      const rightData = transformValuesToBE({
        values,
        rightsHolderAdServer,
        gamNetworkCode
      })

      dispatch(
        createRight({
          ...rightData,
          partnership: partnershipId
        })
      )
    },
    [dispatch, partnershipId, rightsHolderAdServer, gamNetworkCode]
  )

  const clearCreateRightSubmit = useCallback(() => dispatch(clearCreateRight()), [dispatch])

  const formik = useFormik({
    initialValues: getInitialValues({
      isDigitalRightTypeAllowed: selectedPartnershipIsDigital,
      facebookIsConnected,
      isGamAccountConnected
    }),
    validationSchema: getValidationSchema(isGamAccountConnected),
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <Form
      formName={RIGHT_CREATE}
      formik={purifiedFormik}
      successSubmit={rightWasCreated}
      errorSelector={createdRightErrorSelector}
      isLoadingSelector={createdRightIsLoadingSelector}
      clearHandler={clearCreateRightSubmit}
    >
      <NameAndTypeSection formik={purifiedFormik} />
      <RightCreateFormContent formik={purifiedFormik} />
    </Form>
  )
}

export default RightCreateForm
